import { Injectable } from '@angular/core';
import { Firestore, doc, getDoc, setDoc } from '@angular/fire/firestore';

@Injectable()
export class PublishingService {

  constructor(private firestore: Firestore) { }

  // TODO: Does not currently copy embedded collections like Questions

  // Publish draft preferences to make them live in the student application
  async publishDraft(schoolId: string): Promise<void> {
    const publishedDocRef = doc(this.firestore, 'preferences', schoolId);
    const draftDocRef = doc(this.firestore, 'preferences_draft', schoolId);

    const [draftDoc, publishedDoc] = await Promise.all([
      getDoc(draftDocRef),
      getDoc(publishedDocRef),
    ]);
    if (draftDoc.exists()) {
      const live = publishedDoc.data() ?? {};
      await setDoc(publishedDocRef, {
        ...draftDoc.data(),
        status: live['status'] ?? null,
        disableSchool: live['disableSchool'] ?? false,
      });
    }
  }

  // Copy live preferences from live application to draft
  async copyToDraft(schoolId: string): Promise<void> {
    const publishedDocRef = doc(this.firestore, 'preferences', schoolId);
    const draftDocRef = doc(this.firestore, 'preferences_draft', schoolId);

    const publishedDoc = await getDoc(publishedDocRef);
    if (publishedDoc.exists()) {
      await setDoc(draftDocRef, publishedDoc.data());
      location.reload();
    }
  }

  // Copy document from one path to the next
  async utilityCopyDocument(fromDocPath: string, toDocPath: string): Promise<void> {
    const fromDocRef = doc(this.firestore, fromDocPath);
    const toDocRef = doc(this.firestore, toDocPath);

    const fromDoc = await getDoc(fromDocRef);
    if (fromDoc.exists()) {
      await setDoc(toDocRef, fromDoc.data());
    }
  }
}